var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-wrapper" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          staticClass: "logo __pointer",
          on: { mouseenter: _vm.overLogo, mouseleave: _vm.leaveLogo }
        },
        [
          _c("img", { attrs: { src: _vm.viteLogo }, on: { click: _vm.goVX } }),
          _vm._v(" "),
          _c("test-notice", {
            staticClass: "notice",
            class: { hide: !_vm.isShowNotice }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_top" },
        _vm._l(_vm.menuTops, function(name, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "__pointer",
              on: {
                click: function($event) {
                  return _vm._go(name)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "icon",
                  class: { active: _vm.$route.name.indexOf(name) >= 0 }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.$route.name.indexOf(name) < 0,
                        expression: "$route.name.indexOf(name) < 0"
                      }
                    ],
                    attrs: { src: _vm.icon[name] }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.$route.name.indexOf(name) >= 0,
                        expression: "$route.name.indexOf(name) >= 0"
                      }
                    ],
                    attrs: { src: _vm.icon[name + "Active"] }
                  })
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_bottom" },
        [
          _vm._l(_vm.menuBottoms, function(name, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "icon __pointer",
                class: { active: _vm.$route.name === name },
                on: {
                  click: function($event) {
                    return _vm._go(name)
                  }
                }
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$route.name !== name,
                      expression: "$route.name !== name"
                    }
                  ],
                  staticClass: "default",
                  attrs: { src: _vm.icon[name] }
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$route.name === name,
                      expression: "$route.name === name"
                    }
                  ],
                  staticClass: "active",
                  attrs: { src: _vm.icon[name + "Active"] }
                })
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              key: "theme",
              staticClass: "icon __pointer",
              on: { click: _vm.changeTheme }
            },
            [
              _c("font-awesome-icon", {
                staticClass: "theme-icon",
                attrs: { icon: _vm.themeIcon }
              })
            ],
            1
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }